import React, { FC, useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import {
  RHFAutocomplete,
  RHFTextField,
} from "../../RHFComponents/RHFComponents";

type Props = {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  namePrefix: string;
  specialitaDisponibili?: any[];
  prestazioniDisponibili?: any[];
};

const PairedServices: FC<Props> = ({
  open,
  onClose,
  onDelete,
  namePrefix,
  specialitaDisponibili = [],
  prestazioniDisponibili = [],
}) => {
  const { control, trigger, getValues, setValue } = useFormContext();

  const pathOriginalSpecialita = `${namePrefix}.specialita`;
  const pathOriginalPrestazione = `${namePrefix}.prestazione`;
  const pathPairedPrestazione = `${namePrefix}.prestazioneAbbinata`;

  const specialita = useWatch({ control, name: `${namePrefix}.specialita` });
  const prestazione = useWatch({ control, name: `${namePrefix}.prestazione` });

  const [tab, setTab] = useState<number>(0);

  const handleConfirm = async () => {
    // valida solo i campi del modale che ti interessano
    const ok = await trigger([pathPairedPrestazione], { shouldFocus: true });
    if (!ok) return;
    onClose();
  };


  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" keepMounted>
      <Box
        sx={{
          px: 3,
          pt: 2,
          borderColor: "divider",
        }}
      >
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons={false}
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#003267",
              height: 3,
              borderRadius: 1,
            },
          }}
        >
          <Tab
            label="Prestazione abbinata"
            disableRipple
            sx={{
              textTransform: "none",
              fontStyle: "normal",
              fontSize: "14px",
              fontFamily: "Montserrat",
              fontWeight: 700,
              color: "#003267 !important",
              alignItems: "flex-start",
              minHeight: 48,
            }}
          />
        </Tabs>
      </Box>

      <DialogContent>
        {/* Prestazione originale (read-only) */}
        <Box sx={{ mb: 3 }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontFamily: "Rubik",
              mb: 1,
              color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
            }}
          >
            Prestazione originale
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                name={`${pathOriginalSpecialita}.DESCRIZIONE`}
                value={specialita?.DESCRIZIONE ?? ""}
                label="Specialità"
                size="small"
                fullWidth
                InputProps={{ readOnly: true }}
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name={`${pathOriginalPrestazione}.DESPRESTAZIONE`}
                value={prestazione?.DESCRIZIONE ?? ""}
                label="Prestazione"
                size="small"
                fullWidth
                InputProps={{ readOnly: true }}
                disabled
              />
            </Grid>
          </Grid>
        </Box>

        {/* Prestazione abbinata (scrive nel form principale) */}
        <Box sx={{ mb: 3 }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontFamily: "Rubik",
              mb: 1,
              color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
            }}
          >
            Prestazione abbinata
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <RHFAutocomplete
                name={pathPairedPrestazione}
                control={control}
                options={prestazioniDisponibili}
                size="small"
                label="Prestazione"
                getOptionLabel={(o: any) => o?.DESPRESTAZIONE || ""}
                isOptionEqualToValue={(a: any, b: any) =>
                  a?.PRESTAZIONE === b?.PRESTAZIONE
                }
              />
            </Grid>
          </Grid>
        </Box>

        {/* Footer */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
          <Button variant="outlinedError" onClick={onClose}>
            Uscita
          </Button>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="outlined"
              onClick={() => {
                setValue(pathPairedPrestazione, null, {
                  shouldDirty: true,
                  shouldValidate: true,
                });
                onDelete();
              }}
            >
              Elimina Abbinamento
            </Button>
            <Button variant="contained" onClick={handleConfirm}>
              Conferma
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PairedServices;
